import { NgFor, NgIf } from "@angular/common";
import { Component, Input, OnInit,CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { TRANSLOCO_CONFIG, TranslocoModule, TranslocoService } from "@jsverse/transloco";

@Component({
    selector: 'dl-print-registration-key',
    templateUrl: './print-registration-key.component.html',
    styleUrls: ['./print-registration-key.component.scss'],
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [NgIf,TranslocoModule, NgFor]
})

export class PrintRegistrationKeyComponent implements OnInit {

    @Input() tableData = [];
    constructor() {}

    ngOnInit(): void {
    }
}
